import React, { useRef } from "react"
import { mapDispatchProps, mapStateToProps } from "../../../../store/store"
import { connect } from "react-redux"
import { X } from "react-feather"
import dayjs from "../../../../plugins/dayjs"
import API from "../../../../api"
import { BRAND_DTO_ENUMS } from "api/repositories/brand/brand.constants"
import { debounce } from "../../../../helpers/debounce"
import { useLanguage } from "@languages/index"
import { isKoreaService } from "constants/domains/domains"
import Button from "../../../../components/button"
import OverlayBrandTaxInvoiceInfoForm, { OverlayBrandTaxInvoiceInfoFormResult } from "components/overlayBrandTaxInvoiceInfoForm"
import CampaignPaymentCancelComplete from "./complete"

const CampaignPaymentCancelConfirm = (props: any) => {
  const language = useLanguage()
  const languageTexts = { ...language.common, ...language.pages.campaigns }
  const lastCampaignEndsAt = useRef(dayjs(props.brand.lastCampaignEndsAt))
  const lastSeedingPassEndsAt = useRef(dayjs(props.brand.lastSeedingPassEndsAt))

  const requireDates = useRef(
    lastCampaignEndsAt.current.isAfter(lastSeedingPassEndsAt.current)
      ? lastCampaignEndsAt.current.diff(lastSeedingPassEndsAt.current, "days") - 1
      : null
  )

  const showCancelComplete = () => {
    props.closeOverlays()
    debounce(() => {
      props.showOverlays({
        content: () => {
          return <CampaignPaymentCancelComplete />
        },
      })
    }, 400)
  }

  const renderSeedingPassDurationDescriptions = () => {
    // validations
    if (!lastCampaignEndsAt.current) return ""
    if (!lastSeedingPassEndsAt.current) return ""

    // inputs

    // process
    // 캠페인 종료일 > 시딩 패스 종료일
    if (lastCampaignEndsAt.current.isAfter(lastSeedingPassEndsAt.current)) {
      return (
        <span className="text-base tracking-tighter text-start text-[#FF0099]">
          {languageTexts._payments_cancel_confirm_text_1(
            requireDates.current,
            lastCampaignEndsAt.current.format(languageTexts.date_format)
          )}
        </span>
      )
    }

    return (
      <span className="text-base tracking-tighter text-start text-[#FF0099]">
        {languageTexts._payments_cancel_confirm_text_2(lastSeedingPassEndsAt.current.format(languageTexts.date_format))}
      </span>
    )
  }

  const offAutoPurchase = async () => {
    // 현금 결제 브랜드의 경우 세금계산서 정보 입력
    let cashCampaignPaymentData = null
    if (
      isKoreaService() && 
      props.brand.billingType === BRAND_DTO_ENUMS.BILLING_TYPE.FREE &&
      requireDates.current > 0
    ) {
      const brandTaxInvoiceInfoFormResult = await new Promise<OverlayBrandTaxInvoiceInfoFormResult>(
        (resolve, reject) => {
          props.showOverlays({
            
            content: () => (
              <OverlayBrandTaxInvoiceInfoForm
                onComplete={(result) => resolve(result)}
              />
            )
          });
        }
      );
      if (!brandTaxInvoiceInfoFormResult.isSubmitted) {
        return;
      }
      cashCampaignPaymentData = brandTaxInvoiceInfoFormResult.data.campaignPayment;
    }

    API.Brand.update({
      brandToken: props.auth.token,
      isSeedingPassAutoPurchaseEnabled: "false",
      // 이하 취소 결제 관련
      requireDates: requireDates.current,
      taxInvoiceScheduledDate: cashCampaignPaymentData?.taxInvoiceScheduledDate,
      depositScheduledDate: cashCampaignPaymentData?.depositScheduledDate,
    })
      .then((response) => {
        let arr = {
          text: response.data.message,
        }

        if (response.data.title.length) {
          arr["title"] = response.data.title
        }

        showCancelComplete()
      })
      .catch((error) => {
        props.setPopup({
          isVisible: true,
          text: error.message,
        })
      })
  }

  return (
    <div className="flex flex-col bg-white py-10 px-5 md:rounded-2xl min-w-[100vw] md:min-w-[480px] md:max-w-[480px] md:px-10 md:py-10">
      <div className="flex flex-col">
        <div
          className=" cursor-pointer flex flex-row justify-end"
          onClick={() => {
            props.closeOverlays()
          }}
        >
          <X size={24} />
        </div>
        <div className="flex flex-row">
          <div className="flex flex-col pb-2 mb-10">
            <div className="flex flex-col gap-6">
              <span className="font-bold text-[28px] tracking-tighter text-start">
                {languageTexts.payments_cancel_confirm_text_3}
              </span>

              {/* <span className="text-base tracking-tighter text-start">
                {languageTexts._payments_cancel_confirm_text_4(props.settings.currencyText)}
              </span> */}

              {renderSeedingPassDurationDescriptions()}

              <span className="text-base tracking-tighter text-start text-[#FF0099]">
                {languageTexts._payments_cancel_confirm_text_5()}
              </span>
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-4">
          <Button
            buttonColor="BLACK"
            textColor="WHITE"
            text={languageTexts.payments_cancel_confirm_text_6}
            onClick={() => {
              props.closeOverlays()
            }}
          />
          <Button
            text={languageTexts.payments_cancel_confirm_text_7}
            onClick={() => {
              offAutoPurchase()
            }}
          />
        </div>
      </div>
    </div>
  )
}
export default connect(mapStateToProps, mapDispatchProps)(CampaignPaymentCancelConfirm)
